import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';
import HeadJsonLd from '../components/HeadJsonLd';
import { useLanguage } from '../contexts/LanguageContext';

const bntUrl = 'https://bntnews.bg/news/poreden-opit-za-imotna-izmama-vav-varna-naslednici-razbirat-che-lozyata-im-imat-nov-sobsvenik-prosvoil-gi-po-davnost-1413373news.html';

const content = {
  bg: {
    title: 'Адвокат по вещно право и имотни спорове',
    seoTitle: 'Адвокат по вещно право | Варна, София и цяла България',
    description: 'Правна помощ във Варна, София и цяла България при спорове за собственост, придобивна давност, нотариални актове, делба, кадастър и защита от имотни измами.',
    badge: 'ВЕЩНО ПРАВО И НЕДВИЖИМИ ИМОТИ',
    intro: 'Защитаваме собственици, наследници, купувачи и съсобственици при сложни спорове и сделки с недвижими имоти. Представляваме клиенти във Варна, София и пред съдилищата в цяла България, както в съдебни производства, така и при превантивни проверки преди възникването на спор.',
    servicesTitle: 'Правна помощ при имотни казуси',
    services: [
      ['Спорове за собственост и владение', 'Процесуално представителство при оспорено право на собственост, ревандикационни и други вещни искове.'],
      ['Придобивна давност', 'Защита при претенции, че имот е придобит чрез продължително владение, включително анализ на владението и свидетелските доказателства.'],
      ['Оспорване на нотариални актове', 'Правна защита при конкуриращи се документи за собственост и нотариални актове, издадени след обстоятелствена проверка.'],
      ['Защита от имотни измами', 'Навременни действия при съмнителни вписвания, разпореждания без съгласие или опити трето лице да присвои имот.'],
      ['Съсобственост и съдебна делба', 'Уреждане на отношения между съсобственици и наследници, доброволна или съдебна делба.'],
      ['Кадастър и имотни граници', 'Спорове за граници, площ, идентификатори и несъответствия между кадастралната карта и документите за собственост.'],
      ['Предварителни договори и сделки', 'Преглед на документи, преговори, предварителни договори и защита при неизпълнение на сделки с имоти.'],
      ['Проверка на собствеността и тежестите', 'Превантивна проверка в Имотния регистър, анализ на собствеността и установяване на ипотеки, възбрани и други рискове.'],
    ],
    processTitle: 'Как работим',
    process: [
      ['1. Анализ на документите', 'Преглеждаме нотариални актове, скици, удостоверения за наследници, вписвания, договори и наличната кореспонденция.'],
      ['2. Проверка на фактите', 'Установяваме историята на собствеността, вписаните актове, фактическото владение и приложимите срокове.'],
      ['3. Стратегия за защита', 'Предлагаме конкретни извънсъдебни и съдебни действия според риска, доказателствата и целта на клиента.'],
    ],
    mediaLabel: 'МЕДИЙНО УЧАСТИЕ',
    mediaTitle: 'Адвокат Петър Николов пред БНТ за спор за имот, придобит по давност',
    mediaText: 'БНТ представи случая на Веселин и Радослав Радневи, които оспорват нотариален акт за наследствения им имот във Варна. Адвокат Петър Николов коментира правните рискове и необходимостта собствениците периодично да проверяват имотите си. Спорът е висящ и предстои да бъде решен от съда.',
    mediaCta: 'Гледайте репортажа на БНТ',
    consultationTitle: 'Имате спор или съмнение относно недвижим имот?',
    consultationText: 'Ранната проверка и навременната правна реакция могат да предотвратят разпореждане с имота и да запазят важни доказателства.',
    consultationCta: 'Запазете консултация',
  },
  en: {
    title: 'Property Law and Real Estate Disputes in Bulgaria',
    seoTitle: 'Property Law Attorney in Bulgaria | Varna and Sofia',
    description: 'Legal assistance in Varna, Sofia and throughout Bulgaria with ownership disputes, adverse possession, title deeds, partition, cadastral issues and protection against property fraud.',
    badge: 'PROPERTY LAW AND REAL ESTATE',
    intro: 'We represent owners, heirs, buyers and co-owners in complex real estate disputes and transactions in Varna, Sofia and before courts throughout Bulgaria. Our work covers court proceedings as well as preventive legal checks before a dispute arises.',
    servicesTitle: 'Legal assistance with property matters',
    services: [
      ['Ownership and possession disputes', 'Court representation in contested ownership, recovery of possession and other property claims.'],
      ['Adverse possession', 'Defense against claims that property was acquired through long-term possession, including analysis of possession and witness evidence.'],
      ['Challenges to title deeds', 'Legal protection where competing ownership documents exist or a title deed was issued following a circumstantial verification.'],
      ['Protection against property fraud', 'Prompt action in response to suspicious registrations, unauthorized transactions or attempts by third parties to appropriate property.'],
      ['Co-ownership and partition', 'Resolution of relations between co-owners and heirs through voluntary or judicial partition.'],
      ['Cadastre and boundary disputes', 'Disputes concerning boundaries, area, identifiers and discrepancies between cadastral records and ownership documents.'],
      ['Preliminary agreements and transactions', 'Document review, negotiations, preliminary agreements and protection when a real estate transaction is not performed.'],
      ['Title and encumbrance checks', 'Preventive Property Register checks, title analysis and identification of mortgages, attachments and other risks.'],
    ],
    processTitle: 'How we work',
    process: [
      ['1. Document review', 'We review title deeds, cadastral plans, inheritance certificates, registrations, agreements and available correspondence.'],
      ['2. Verification of facts', 'We establish the ownership history, registered instruments, factual possession and applicable limitation periods.'],
      ['3. Legal strategy', 'We recommend specific out-of-court and court measures based on the risk, evidence and the client’s objective.'],
    ],
    mediaLabel: 'MEDIA APPEARANCE',
    mediaTitle: 'Attorney Petar Nikolov on BNT about a property dispute involving adverse possession',
    mediaText: 'Bulgarian National Television reported on the case of Veselin and Radoslav Radnev, who are challenging a title deed concerning their inherited property in Varna. Attorney Petar Nikolov discussed the legal risks and the importance of regularly checking property records. The dispute is pending and will be decided by the court.',
    mediaCta: 'Watch the BNT report',
    consultationTitle: 'Do you have a dispute or concern involving real estate?',
    consultationText: 'An early review and prompt legal action can prevent further dealings with the property and preserve important evidence.',
    consultationCta: 'Schedule a consultation',
  },
};

export default function PropertyLaw() {
  const { language } = useLanguage();
  const page = content[language];
  const canonical = language === 'bg'
    ? 'https://advokatnikolov.com/veshtno-pravo-nedvizhimi-imoti'
    : 'https://advokatnikolov.com/property-law-real-estate';

  React.useEffect(() => {
    document.body.setAttribute('data-lang', language);
    document.documentElement.setAttribute('lang', language);
    window.scrollTo(0, 0);
  }, [language]);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    name: language === 'bg' ? 'Вещно право и недвижими имоти' : 'Property Law and Real Estate',
    description: page.description,
    provider: {
      '@type': 'LegalService',
      name: language === 'bg' ? 'Адвокатска кантора Петър Николов' : 'Petar Nikolov Law Firm',
      url: 'https://advokatnikolov.com',
      telephone: '+359882744951',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'бул. Цар Освободител 44, ет. 4, офис 6',
        addressLocality: 'Варна',
        addressCountry: 'BG',
      },
    },
    areaServed: ['Varna', 'Sofia', 'Bulgaria'],
    serviceType: page.services.map(([title]) => title),
  };

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{page.seoTitle}</title>
        <meta name="description" content={page.description} />
        <link rel="canonical" href={canonical} />
        <link rel="alternate" hrefLang="bg" href="https://advokatnikolov.com/veshtno-pravo-nedvizhimi-imoti" />
        <link rel="alternate" hrefLang="en" href="https://advokatnikolov.com/property-law-real-estate" />
      </Helmet>
      <HeadJsonLd id="property-law-jsonld" data={structuredData} />
      <NavBar />

      <main>
        <section className="pt-32 pb-20 bg-gradient-to-br from-navy via-navy/95 to-accent text-white">
          <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
            <span className="inline-flex rounded-full bg-gold/15 border border-gold/30 px-4 py-2 text-sm font-semibold tracking-wide text-gold mb-6">{page.badge}</span>
            <h1 className="text-4xl md:text-5xl font-serif mb-6">{page.title}</h1>
            <p className="max-w-3xl mx-auto text-lg md:text-xl leading-relaxed text-gray-200">{page.intro}</p>
            <a href="/#contact" className="btn-primary inline-flex mt-10">{page.consultationCta}</a>
          </div>
        </section>

        <section className="py-16 lg:py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h2 className="section-title text-center mb-12">{page.servicesTitle}</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {page.services.map(([title, description]) => (
                <article key={title} className="rounded-2xl border border-gray-100 bg-white p-7 shadow-lg">
                  <div className="flex items-start gap-4">
                    <span className="mt-2 h-2.5 w-2.5 shrink-0 rounded-full bg-gold" />
                    <div>
                      <h3 className="text-xl font-serif text-navy mb-2">{title}</h3>
                      <p className="text-slate leading-relaxed">{description}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 lg:py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-6 lg:px-8">
            <h2 className="section-title text-center mb-12">{page.processTitle}</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {page.process.map(([title, description]) => (
                <article key={title} className="rounded-2xl bg-white p-7 shadow-md">
                  <h3 className="text-xl font-serif text-navy mb-3">{title}</h3>
                  <p className="text-slate leading-relaxed">{description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 lg:py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <article className="rounded-2xl bg-navy p-8 md:p-10 text-white shadow-xl">
              <span className="text-sm font-semibold tracking-wide text-gold">{page.mediaLabel}</span>
              <h2 className="text-3xl font-serif mt-3 mb-5">{page.mediaTitle}</h2>
              <p className="text-gray-200 leading-relaxed mb-7">{page.mediaText}</p>
              <a href={bntUrl} target="_blank" rel="noopener noreferrer" className="inline-flex rounded-lg bg-gold px-6 py-3 font-semibold text-navy transition hover:bg-yellow-500">{page.mediaCta}</a>
              <p className="mt-4 text-sm text-gray-400">{language === 'bg' ? 'Източник: Българска национална телевизия, репортер Петър Дойкински, 20 септември 2026 г.' : 'Source: Bulgarian National Television, reporter Petar Doykinski, September 20, 2026.'}</p>
            </article>
          </div>
        </section>

        <section className="py-16 lg:py-20 bg-gradient-to-br from-gold/20 to-gold/5">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-serif text-navy mb-5">{page.consultationTitle}</h2>
            <p className="text-lg text-slate leading-relaxed mb-8">{page.consultationText}</p>
            <a href="/#contact" className="btn-primary inline-flex">{page.consultationCta}</a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
